export default __webpack_public_path__ + "static/media/cuideigin.e6a215c6.mp3";